module.exports = __webpack_public_path__ + "img/emoji-heart-240x240.03aed0d3.png";